var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { selectAppContent, selectStyles } from "@adm-media/adam-store-plugin";
import classNames from "classnames";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { BlockWrapper } from "../../wrappers/BlockWrapper/BlockWrapper";
import { SanitizeHtml } from "../../ui/SanitizeHtml/SanitizeHtml";
import { useAnimationClassName } from "../../../hooks/useAnimationClassName";
import "./Info.scss";
import { Typography } from "antd";
var InfoTitle = function (_a) {
    var children = _a.children, baseClass = _a.baseClass, animation = _a.animation, _b = _a.titleLevel, titleLevel = _b === void 0 ? 2 : _b;
    var titleRef = useRef(null);
    var titleAnimationClass = useAnimationClassName({ ref: titleRef, animation: animation });
    return (_jsx(Typography.Title, __assign({ ref: titleRef, style: { marginBottom: 20 }, className: "".concat(baseClass, "__title ").concat(titleAnimationClass), level: titleLevel }, { children: children })));
};
var Info = function (_a) {
    var _b = _a.centered, centered = _b === void 0 ? true : _b, animation = _a.animation, props = __rest(_a, ["centered", "animation"]);
    var styles = useSelector(selectStyles);
    if (!styles.show_intro_section) {
        return null;
    }
    var contents = useSelector(selectAppContent);
    var baseClass = "block-info";
    var contentRef = useRef(null);
    var contentAnimationClass = useAnimationClassName({ ref: contentRef, animation: animation });
    var className = classNames("websiteInfo", { centered: centered });
    return contents.website_intro ? (_jsxs(BlockWrapper, __assign({ id: "info" }, props, { className: className, "data-testid": "block-info" }, { children: [_jsx(InfoTitle, { children: contents.intro_title || "Welcome to ".concat(contents.event_title), titleLevel: props.titleLevel, baseClass: baseClass, animation: animation }), _jsx("div", __assign({ ref: contentRef, className: contentAnimationClass }, { children: _jsx(SanitizeHtml, { className: "websiteInfo__container", stringToSanitize: contents.website_intro, tag: "div" }) }))] }))) : null;
};
export default Info;
